;(() => {
    const collection = document.querySelectorAll('[data-prevent-event]')
    Array.from(collection).forEach(el => {
        if (el) {
            const eventName = el.dataset.preventEvent
            el.addEventListener(eventName, e => e.preventDefault())
        }
    })
})()
